import { Autocomplete, Box, TextField } from "@mui/material";
import { CalenderViewButton } from "component/atoms/calender-view-button";
import { ThemeButton } from "component/atoms/theme-button";
import { CalenderButtonGroup } from "component/molecules/calender-button-group";
import { RefreshButton } from "component/atoms/refresh-button";
import { useGetUsers } from "hook/useGetUsers";
import { useEventConfigArray } from "hook/use-event-config-array";
import { useCalenderConfig } from "hook/use-calender-config";
import { useEffect, useRef } from "react";

const DAY = "day";
const WEEK = "week";
const MONTH = "month";

export const HeaderLine = ({
  selectedUsers,
  setSelectedUsers,
  //
  selectedConfigs,
  setSelectedConfigs,
  //
  selectedView,
  setSelectedView,
}) => {
  const userArray = useGetUsers();
  const eventConfigArray = useEventConfigArray();
  const { calenderConfig } = useCalenderConfig();
  const selectedConfigRef = useRef([]);
  const savedCalendarView = calenderConfig?.calenderView;

  useEffect(() => {
    if (selectedUsers?.length === 0 && userArray?.length > 0) {
      setSelectedUsers(userArray);
    }
  }, [selectedUsers, userArray]);

  useEffect(() => {
    if (selectedConfigs?.length === 0 && eventConfigArray?.length > 0) {
      if (selectedConfigRef.current?.length === 0) {
        selectedConfigRef.current = eventConfigArray.map((el) => el?.setting_id);
        setSelectedConfigs(eventConfigArray);
      } else {
        setSelectedConfigs(eventConfigArray?.filter((el) => selectedConfigRef.current.includes(el.setting_id)));
      }
    }
  }, [selectedConfigs, eventConfigArray]);

  useEffect(() => {
    if (selectedView === null) {
      if (savedCalendarView) {
        setSelectedView(savedCalendarView);
      } else {
        setSelectedView(MONTH);
      }
    }
  }, [selectedView, savedCalendarView]);

  const initialDataLoaded = selectedView && selectedUsers.length > 0 && selectedConfigs.length > 0;

  return (
    <Box
      sx={{
        p: "10px",
        display: "flex",
        alignItems: "center",
        bgcolor: "white",
        ...(initialDataLoaded ? {} : { height: "60px" }),
      }}
    >
      {initialDataLoaded ? (
        <>
          <Box sx={{ display: "flex", gap: "1rem", flexGrow: 1 }}>
            <Autocomplete
              options={userArray}
              filterSelectedOptions={true}
              value={selectedUsers}
              onChange={(e, value) => {
                if (value?.length === 0) {
                  setSelectedUsers([userArray?.[0]]);
                  return;
                }
                setSelectedUsers(value);
              }}
              disablePortal
              sx={{ minWidth: 200, maxWidth: 700 }}
              size="small"
              multiple
              limitTags={2}
              getOptionLabel={(option) => option?.name}
              renderInput={(params) => <TextField {...params} placeholder="Select user" />}
            />
            <Autocomplete
              options={eventConfigArray}
              filterSelectedOptions={true}
              value={selectedConfigs}
              onChange={(e, value) => {
                if (value?.length === 0) {
                  setSelectedConfigs([eventConfigArray?.[0]]);
                  selectedConfigRef.current = [eventConfigArray?.[0]?.setting_id];
                  return;
                }
                setSelectedConfigs(value);
                selectedConfigRef.current = value?.map((obj) => obj?.setting_id);
                /*    if (selectedConfigRef.current.includes(value.setting_id)) {
                  console.log(selectedConfigRef.current.includes(value.setting_id), selectedConfigRef.current);

                  selectedConfigRef.current = selectedConfigRef.current?.filter((id) => id !== value?.setting_ids);
                } else {
                  selectedConfigRef.current = [...selectedConfigRef.current, value?.setting_ids];
                } */
              }}
              // disabled={moduleArray?.length < 1}
              sx={{ minWidth: 200, maxWidth: 700 }}
              disablePortal
              size="small"
              multiple
              limitTags={2}
              getOptionLabel={(option) => {
                return `${option?.module?.plural_label}: ${option?.activity}`;
              }}
              renderInput={(params) => <TextField {...params} placeholder="Select setting" />}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              justifyContent: "space-between",
              flexGrow: 4,
              alignItems: "center",
            }}
          >
            <CalenderButtonGroup>
              <CalenderViewButton
                active={selectedView === DAY}
                label="Day"
                onClick={() => {
                  setSelectedView(DAY);
                }}
              />
              <CalenderViewButton
                active={selectedView === WEEK}
                label="Week"
                onClick={() => {
                  setSelectedView(WEEK);
                }}
              />
              <CalenderViewButton
                active={selectedView === MONTH}
                label="Month"
                onClick={() => {
                  setSelectedView(MONTH);
                }}
              />
            </CalenderButtonGroup>
            {/* <ThemeButton /> */}
          </Box>
        </>
      ) : null}
      <RefreshButton setSelectedConfigs={setSelectedConfigs} />
    </Box>
  );
};
